<template>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
         <FormItem label="公告标题" prop="title">
            <i-input v-model="formValidate.title" class="titleinput" placeholder="请输入公告标题"></i-input>
        </FormItem>
        <FormItem label="公告内容" >
           <div ref="editor" style="text-align:left"></div>
        </FormItem>
         <FormItem label="集团方是否接受" prop="receive_company">
            <RadioGroup v-model="formValidate.receive_company">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
            </RadioGroup>
        </FormItem> 
        <FormItem label="接收集团" prop="company_id"> 
       <RadioGroup v-model="companyidtype" type="button" @on-change="searchcompany">
         <Radio label="1">全部</Radio>
         <Radio label="0">单个</Radio>
       </RadioGroup>
              <Select v-if="companyidtype=='0'" v-model="formValidate.company_id"  style="width:260px" @on-change="searchhotel">
                <Option v-for="item in mycompanylist" :value="item.id" :key="item.id">{{ item.name }}</Option>
             </Select>
        </FormItem>
        <FormItem label="酒店方是否接受" prop="receive_hotel">
            <RadioGroup v-model="formValidate.receive_hotel">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
            </RadioGroup>
        </FormItem> 
           <FormItem label="接收酒店" prop="company_id"> 
       <RadioGroup v-model="hotelidtype" type="button" @on-change="searchhotel">
         <Radio label="1">全部</Radio>
         <Radio label="0">单个</Radio>
       </RadioGroup>
              <Select v-if="hotelidtype=='0'&&formValidate.company_id" v-model="formValidate.hotel_id"  style="width:260px">
                <Option v-for="item in myhotellist" :value="item.id" :key="item.id">{{ item.name }}</Option>
             </Select>
        </FormItem>       
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
        </FormItem>
    </Form>
</template>
<style scoped>
.titleinput {
  width: 200px;
}
</style>

<script>
import E from "wangeditor";
import { createnotice } from "../../api/noticeapi";
import { companylist , hotel_list } from "../../api/companyapi";
export default {
  name: "editor",
  data() {
    return {
      editorContent: "",
      formValidate: {
        title: "",
        receive_company: "0",
        receive_hotel: "0",
        company_id: "",
        hotel_id: ""
      },
      hotelidtype: "1",
      mycompanylist: [],
      myhotellist: [],
      companyidtype: "1",
      ruleValidate: {
        title: [{ required: true, message: "请输入", trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.typestate = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.addnotice();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    searchcompany(e) {
      if (e == "0" && this.mycompanylist.length == 0) {
        this.companylist();
      }else if(e=='1'){
          this.formValidate.company_id="";
          this.formValidate.hotel_id="";
          this.hotelidtype = "1"
      }
    },
    searchhotel(){
      if(this.hotelidtype=='0' && this.formValidate.company_id){
        this.hotel_list();
      }else if(this.hotelidtype=='1'){
     
          this.formValidate.hotel_id="";
      }
    },
    hotel_list(){
            var _this = this;
      let para = {
       company_id:this.formValidate.company_id
      };
      hotel_list(para).then(res => {
        var data = res.data.data;
        var myhotellist = [];
        data.forEach(element => {
          myhotellist.push({
            id: element.id,
            name: element.name
          });
        });
        _this.myhotellist = myhotellist;
      });
    },
    companylist() {
      var _this = this;
      let para = {
        page: 1,
        pagesize: 10000
      };
      companylist(para).then(res => {
        var data = res.data.data.data;
        var companylist = [];
        data.forEach(element => {
          companylist.push({
            id: element.id,
            name: element.name
          });
        });
        _this.mycompanylist = companylist;
      });
    },
    addnotice() {
     
     var para = {
       
        title: this.formValidate.title,
        content: this.editorContent,
        // company_id: this.formValidate.company_id,
        receive_company:
          this.formValidate.receive_company == "1" ? 1 : 0,
        receive_hotel: this.formValidate.receive_hotel == "1" ? 1 : 0,
        // hotel_id: this.formValidate.hotel_id
      };
      if(this.formValidate.company_id){
        para.company_id=this.formValidate.company_id
      }
      if(this.formValidate.hotel_id){
        para.hotel_id=this.formValidate.hotel_id
      }

      this.$Loading.start();
      createnotice(para).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
        } else {
          this.$Message.error(data.message);
        }
      });
    }
  },

  mounted() {
     if (sessionStorage.getItem("loginType")) {
      this.loginType = JSON.parse(sessionStorage.getItem("loginType"));
    }
    let timestamp = new Date().getTime();
   if (this.loginType == "正式") {
        var url =
          "https://www.migee.net/index.php/common/component/upload?device=PC" +
          "&timestamp=" +
          timestamp;
    } else if (this.loginType == "测试") {
        var url =
          "https://test.migee.net/index.php/common/component/upload?device=PC" +
          "&timestamp=" +
          timestamp;
      }
    var editor = new E(this.$refs.editor);
    //    editor.customConfig.uploadImgServer = 'https://test.migee.net/index.php/common/component/upload?device=PC&timestamp=1533532250196'
    editor.customConfig.uploadImgMaxLength = 1;
    //    editor.customConfig.uploadFileName="file";
    //    editor.customConfig.uploadImgParams = {
    //     imagesize:"editor",
    //     type:"editor",
    //  }
    
    editor.customConfig.customUploadImg = function(files, insert) {
      var file = files;
      var formData = new FormData();
      formData.append("file", file[0]);
      formData.append("type", "editor");
      formData.append("imagesize", "hotel_detail_preview");
      var xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        url,
        true
      );
      xhr.upload.onprogress = function(event) {};
      xhr.onload = function() {
        if (xhr.status == 200 && xhr.readyState == 4) {
          var response = xhr.response;
          response = $.parseJSON(response);
          if (response.code == 1) {
            insert(response.data.url);
          } else {
          }
        }
      };
      xhr.send(formData);
    };
    editor.customConfig.onchange = html => {
      this.editorContent = html;
    };
    editor.create();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/notice/add.vue